import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}/user`;

export function updateUser(data, token, id = "me") {
  return axios.patch(`${base}/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function getUsers(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/users${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getUserById(token, id) {
  return axios.get(`${baseUrl}/user/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function updateUserById(token, id, data) {
  return axios.patch(`${baseUrl}/user/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function deleteUserById(id, token) {
  return axios.delete(`${baseUrl}/user/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function createUser(token, data) {
  return axios.post(`${baseUrl}/user`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function activateUserById(id, token) {
  return axios.put(
    `${baseUrl}/activateUser/${id}`,
    {},
    {
      headers: {
        authorization: token,
      },
    }
  );
}
export function deactivateUserById(id, token) {
  return axios.put(
    `${baseUrl}/deactivateUser/${id}`,
    {},
    {
      headers: {
        authorization: token,
      },
    }
  );
}
// const userListsCacheMap = new Map();
// export function getUserList (token) {
//     console.log(userListsCacheMap);
//     if (!userListsCacheMap.has(token)) {
//         userListsCacheMap.set(token, getList(token));
//     }
//     return userListsCacheMap.get(token);
// };
export function getUserList(token) {
  return axios.get(`${baseUrl}/users/list`, {
    headers: {
      authorization: token,
    },
  });
}
export function getUserListByCaseId(token, caseId) {
  return axios.get(`${baseUrl}/users/list/${caseId}`, {
    headers: {
      authorization: token,
    },
  });
}
